import React from "react";
import Header from "./Header";
import { process } from "../../Data/data";

const Process = () => {
  return (
    <div className="w-full h-full bg-black px-5 py-14 flex justify-center items-center gap-8 flex-wrap sm:px-8 lg:px-16 lg:py-20">
      <Header
        title={"Our Process"}
        subtitle={"How We Manage Your Property from Start to Finish"}
        description={
          "Managing residential and commercial properties in San Francisco and the Bay Area can be complex. Our proven six-step process ensures every property is professionally maintained, compliant, and optimized for maximum returns — while giving you complete peace of mind."
        }
      />
      <div className="grid w-full max-w-[1320px] grid-cols-1 gap-5 mt-2 sm:grid-cols-2 xl:grid-cols-3">
        {process.map((data, index) => (
          <div key={index} className="w-full min-h-[270px]">
            <div className="flex justify-center items-center p-[1rem] border-l border-l-[#EEC24B]">
              <h1 className="text-gradient font-bold text-[20px]">Step 0{data.id}</h1>
            </div>
            <div className="relative overflow-hidden border 
            border-[#262626] w-full min-h-[220px] rounded-r-md rounded-bl-md
            flex justify-center items-center flex-col gap-[1rem] p-2
            ">
               <div
  className="absolute top-[-28%] left-0 h-full pointer-events-none"
  style={{
    width: "20%", // adjust width as needed
    background: "linear-gradient(130deg, #eec24b6e 8.76%, rgba(238, 194, 75, 0) 50.09%)",
  }}
></div>
             <h1 className="font-bold text-[26px] text-gradient">{data.title}</h1>
             <p className="font-light text-[18px] text-center text-white">{data.detail}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Process;
